import { mode, transparentize } from '@chakra-ui/theme-tools';
import { getOutlineStyle } from './input';
const sizes = {
    xl: {
        button: {
            fontSize: 'lg',
            h: '3rem',
        },
        option: {
            fontSize: 'lg',
            h: '2.25rem',
            lineHeight: '2.25rem',
        },
    },
    lg: {
        button: {
            fontSize: 'lg',
            h: '2.625rem',
        },
        option: {
            fontSize: 'lg',
            h: '2.25rem',
            lineHeight: '2.25rem',
        },
    },
    md: {
        button: {
            fontSize: 'lg',
            h: '2.225rem',
        },
        option: {
            fontSize: 'lg',
            h: '2.25rem',
            lineHeight: '2.25rem',
        },
    },
    sm: {
        button: {
            fontSize: 'md',
            h: '1.875rem',
        },
        option: {
            fontSize: 'md',
            h: '1.875rem',
            lineHeight: '1.875rem',
        },
    },
};
const getBaseStyle = (props) => {
    const { field } = getOutlineStyle(props);
    return {
        wrapper: {
            display: 'inline-block',
            width: '100%',
            height: 'fit-content',
            position: 'relative',
            cursor: 'default',
        },
        button: {
            ...field,
            ...(props.open ? field._focus : {}),
            ...((props.isPlaceholderActive &&
                // unfortunately, the chakra types do not follow our extensions
                field._placeholder) ||
                {}),
            outline: 'none',
            borderRadius: 'base',
            lineHeight: 2.1,
            textAlign: 'left',
            paddingLeft: '0.75em',
            paddingRight: '1.75em',
            cursor: 'default',
            width: '100%',
        },
        listbox: {
            bg: mode('white', 'gray.550')(props),
            borderRadius: '0.25em',
            border: '1px solid',
            borderColor: mode(transparentize('gray.500', 0.24), transparentize('gray.0', 0.24))(props),
            color: 'inherit',
            boxShadow: 'md',
            paddingY: '0.5em',
            position: 'absolute',
            listStyleType: 'none',
            maxH: '8em',
            overflowY: 'auto',
            overflowX: 'hidden',
            width: '100%',
            zIndex: 'dropdown',
        },
        icon: {
            color: '',
            right: 2,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 5,
            height: 5,
            pointerEvents: 'none',
            position: 'absolute',
        },
        option: {
            position: 'relative',
            paddingX: 3,
            paddingY: 0,
            width: '100%',
            fontSize: props.size === 'sm' ? 'sm' : undefined,
            lineHeight: props.size === 'sm' ? '24px' : '36px',
            ...(props.selected
                ? {
                    color: 'white',
                    background: 'blue.400',
                }
                : {}),
        },
    };
};
export default {
    baseStyle: getBaseStyle,
    sizes,
};
//# sourceMappingURL=custom-select.js.map